import userApi from '../../../../api/userApi';
import { AccountType } from '../../../../api/userApi/types';
import UpgradeBanner from '../UpgradeBanner';
import PaygUsage from './components/PaygUsage';
import SubscribedUsage from './components/SubscribedUsage';

type Props = {
  apiKey: string;
};

const UsageContainer = ({ apiKey }: Props) => {
  const { data: userInfo } = userApi.useGetUserInfoQuery();

  switch (userInfo?.apiSettings.status) {
    case AccountType.Free:
      return <UpgradeBanner />;
    case AccountType.Subscribed:
      return <SubscribedUsage apiKey={apiKey} />;
    case AccountType.Payg:
      return <PaygUsage apiKey={apiKey} />;
    default:
      return null;
  }
};

export default UsageContainer;
